import React, { useState } from "react";
import { getFileIcon } from "../utils/Icon";
import { useNavigate } from "react-router-dom";
import { value } from "../data/data";
import InlineHoverTabs from "./InlineHoverTabs";

const FileInformation = ({ showInfoModal, infoFile, onClose }) => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);

  if (!showInfoModal || !infoFile) return null;

  const accessInfo = value?.find(
    (v) => v.mainaccess?.toLowerCase() === infoFile.name?.toLowerCase()
  );

  const handleItemClick = (item) => {
    if (item.isDirectory) {
      navigate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  return (
    <div className="fixed inset-0 top-0 z-50 flex justify-end items-start">
      <div className="  bg-four rounded-l-lg w-[220px] h-full max-h-screen flex flex-col">
        {/* Header */}
       <div className="flex-1 overflow-y-auto p-5 space-y-4">
         <div className="flex justify-between items-center mt-[5%]">
          <h3 className="text-xl font-semibold text-secondary">File Info</h3>
          <img
            src="/assets/Close.png"
            alt="Close"
            className="w-5 h-5 cursor-pointer hover:scale-110 transition-transform"
            onClick={onClose}
          />
        </div>

        {/* Section Title */}
        <h4 className="text-secondary text-sm font-semibold uppercase tracking-wide mt-3">
    Details
        </h4>

        {/* Preview Image */}
        <div className="flex justify-center items-center mb-6">
          <div className="w-[50px] h-[50px] object-cover shadow">
            <img
              src={getFileIcon(infoFile.name, infoFile.url)}
              alt={infoFile.name}
              onClick={() => handleItemClick(infoFile)}
              className={`w-full h-full object-cover cursor-pointer transition-all duration-300 ${
                infoFile.isLocked && !infoFile.isDirectory
                  ? "blur-sm opacity-50 cursor-not-allowed"
                  : ""
              }`}
            />
          </div>
        </div>

        {/* Access Info */}
        <div className="mb-6">
          <h4 className="text-secondary text-sm font-semibold uppercase tracking-wide mb-2">
            Access
          </h4>
          <div className="flex items-center gap-2">
            {accessInfo?.profile && (
              <img
                src={accessInfo.profile}
                alt="profile"
                className="w-6 h-6 rounded-full"
              />
            )}
            <span className="text-gray-800 font-medium text-sm">
              {accessInfo?.mainaccess || "--"}
            </span>
            {accessInfo?.avatar && (
              <img
                src={accessInfo.avatar}
                alt="avatar"
                className="w-6 h-6 rounded-full"
              />
            )}
          </div>
          {accessInfo?.accessTabs?.length > 0 && (
            <div className="mt-2">
              <InlineHoverTabs tabs={accessInfo.accessTabs} />
            </div>
          )}
        </div>

        {/* File Metadata */}
        <div className="space-y-5">
          {[
            { label: "Name", value: infoFile.name },
            { label: "Type", value: infoFile.isDirectory ? "Folder" : "File" },
            { label: "Size", value: infoFile.size || "N/A" },
            { label: "Created At", value: infoFile.createdAt?.slice(0, 10) || "N/A" },
            { label: "Updated At", value: infoFile.updatedAt?.slice(0, 10) || "N/A" },
          ].map((item, i) => (
            <div key={i}>
              <label className="block text-sm font-semibold text-secondary mb-1">
                {item.label}
              </label>
              <div className="text-gray-700 text-sm">{item.value}</div>
            </div>
          ))}
          {/* <div className=" mb-2">
            <label className="block text-sm font-semibold text-secondary mb-1">Description</label>
            <textarea className=" border w-full px-4 py-2"></textarea>
          </div> */}
        </div>

       
       </div>
        
      </div>
    </div>
  );
};

export default FileInformation;
